/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import {
  GetMeProfileResponseData,
  GetMeProfileResponseDataFromJSON,
  GetMeProfileResponseDataFromJSONTyped,
  GetMeProfileResponseDataToJSON
} from './GetMeProfileResponseData'

/**
 *
 * @export
 * @interface UpdateMeProfileResponse
 */
export interface UpdateMeProfileResponse {
  /**
   *
   * @type {number}
   * @memberof UpdateMeProfileResponse
   */
  status?: number
  /**
   *
   * @type {GetMeProfileResponseData}
   * @memberof UpdateMeProfileResponse
   */
  data?: GetMeProfileResponseData
}

export function UpdateMeProfileResponseFromJSON(json: any): UpdateMeProfileResponse {
  return UpdateMeProfileResponseFromJSONTyped(json, false)
}

export function UpdateMeProfileResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateMeProfileResponse {
  if (json === undefined || json === null) {
    return json
  }
  return {
    status: !exists(json, 'status') ? undefined : json['status'],
    data: !exists(json, 'data') ? undefined : GetMeProfileResponseDataFromJSON(json['data'])
  }
}

export function UpdateMeProfileResponseToJSON(value?: UpdateMeProfileResponse | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    status: value.status,
    data: GetMeProfileResponseDataToJSON(value.data)
  }
}
